// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n  /* // .el-upload--picture-card 控制加号部分\n  :deep(.hide .el-upload--picture-card) {\n      display: none;\n  } */\n.el-icon-document[data-v-6b32f042]{\n    width: 180px;\n    white-space: nowrap;\n    overflow: hidden;\n}\n  ", ""]);
// Exports
module.exports = exports;
